import React from 'react'
import styled from '@emotion/styled'

import { colors, styles } from 'Constants'

import { useStore } from 'laco-react'
import { ModalStore } from 'Store'

import { Flex } from 'lese'

const Modal = styled(Flex)`
  position: fixed;
  z-index: 1000;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.2);

  > * {
    z-index: 100;
  }
`

const ModalClickArea = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
`

export default () => {
  const modalState = useStore(ModalStore)

  if (modalState.components.length === 0) return

  const close = () =>
    ModalStore.set(({ components }) => ({
      components: components.slice(0, components.length - 1)
    }))

  window.addEventListener('popstate', close)

  return modalState.components.map(component => (
    <Modal relative xAlign="space-around" yAlign>
      <ModalClickArea onClick={close} />
      {component}
    </Modal>
  ))
}
